import { createStore } from '../core/store';
import type { Box } from '../brand/logo-geometry';

/** Where the corner mark is drawn on the canvas (its visible part), for windows to keep clear of. */
export const brandBox = createStore<Box | null>(null);
